import { Button } from '@mui/material';
import React from 'react';
import { colors } from '../index';

export default function CancelButton({ disabled, onClick }) {
  return (
    <Button
      variant="outlined"
      type="button"
      disabled={disabled}
      onClick={onClick}
      sx={{ border: `2px solid ${colors.primary}`, color: colors.primary }}
    >
      Cancel
    </Button>
  );
}
